// prettier-ignore
import { memo, FC, SVGProps } from "react"

/* prettier-ignore-start */

const CONFIGS = {
  CONTEXT: [1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1],
  HEART: [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0],
  PLUS: [0, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0, 1, 0],
  DIAMOND: [0, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 0],
}

/* prettier-ignore-end */

const POSITIONS = [
  [3, 3],
  [10, 3],
  [17, 3],
  [6.5, 6.5],
  [13, 6.5],
  [3, 10],
  [10, 10],
  [17, 10],
  [6.5, 13.5],
  [13, 13.5],
  [3, 17],
  [10, 17],
  [17, 17],
]

const RADIUS = 1.3

export const ContextIcon: FC<SVGProps<SVGSVGElement> & { config?: keyof typeof CONFIGS }> = memo(
  ({ config = "CONTEXT", ...props }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      {POSITIONS.map(([cx, cy], i) => (
        <circle
          key={i}
          cx={cx}
          cy={cy}
          r={RADIUS}
          opacity={(!(CONFIGS[config] || CONFIGS.CONTEXT)[i] && "0.2") || undefined}
        />
      ))}
    </svg>
  )
)
export default ContextIcon
